export default __webpack_public_path__ + "static/SLACabaret-Square-61abf7f938b80d6dcf81a40e270c6a9a.jpg";